import React, { Component } from 'react'
import { connect } from 'react-redux'
import { StickyContainer, Sticky } from 'react-sticky'

import classNames from './UpdateKeywordVisibility.css'
import { fetchKeywordGraph, mergeNodes, deleteNode, touchNode } from '../redux/keywords'
import KeywordGraphPicker from '../components/KeywordGraphPicker'

class UpdateKeywordStructure extends Component {
  state = {
    selected: [],
    saving: false,
    updating: false,
    error: null,
    enableAllNewNodes: false
  }
  updateGraph = () => {
    this.setState({
      saving: false,
      updating: true
    })
    return this.props.fetchKeywordGraph().then(() => {
      this.setState({
        selected: [],
        updating: false
      })
    })
  }
  onSave = () => {
    this.setState({
      saving: true,
      error: null
    })
    this.props.mergeNodes(this.state.selected[0]._id, this.state.selected[1]._id)
      .then(data => {
        if (data.result.nodes_merged && data.result.parent_update.length === 0) {
          // No common parent, so whole graph must be refreshed
          return this.updateGraph()
        }
        this.onSuccess()
      }, this.onError)
  }
  onDelete = () => {
    this.setState({ saving: true, error: null })
    this.props.deleteNode(this.state.selected[0]._id)
      .then(
        this.onSuccess,
        this.onError
      )
  }
  onTouchNode = () => {
    this.setState({ saving: true, error: null })
    this.props.touchNode(this.state.selected[0], 'structure__updated_at')
      .then(
        this.onSuccess,
        this.onError
      )
  }
  onSuccess = () => {
    this.setState({
      selected: [],
      saving: false
    })
  }
  onError = error => {
    this.setState({
      saving: false,
      error
    })
    window.alert(`An error occured: ${error.message || error.statusText}`)
  }
  onSelect = node => {
    const { selected } = this.state
    const index = selected.findIndex(n => n._id === node._id)
    if (index === -1 && selected.length < 2) {
      if (selected.length === 1) {
        if (selected[0].isOld && !node.isNew) {
          return
        }
        if (selected[0].isNew && !node.isOld) {
          return
        }
      }
      this.setState({
        selected: selected.concat(node).slice(-2),
        error: null
      })
    } else {
      this.setState({
        selected: selected.filter(n => n._id !== node._id),
        error: null
      })
    }
  }
  onCancel = () => {
    this.setState({ selected: [] })
  }
  toggleQuiteNewNodes = () => {
    this.setState({
      enableAllNewNodes: !this.state.enableAllNewNodes
    })
  }
  renderHeader () {
    const { selected, saving, updating } = this.state

    const oldNode = selected.filter(n => n.isOld)[0]
    const newNode = selected.filter(n => n.isNew)[0]

    return (
      <Sticky className={classNames.header}>
        <div className={oldNode ? classNames.headerNode : classNames.headerNodeEmpty}>
          <div className={classNames.headerNodeHeading}>
            Old Node
          </div>
          {oldNode ? oldNode.name : 'None'}
        </div>
        <div className={newNode ? classNames.headerNode : classNames.headerNodeEmpty}>
          <div className={classNames.headerNodeHeading}>
            New Node
          </div>
          {newNode ? newNode.name : 'None'}
        </div>
        {selected.length === 1 && selected[0].isOld &&
          <button
            onClick={this.onDelete}
            className={classNames.deleteButton}
            disabled={saving || updating}>
            {updating ? 'Refreshing…' : (saving ? 'Deleting…' : 'Delete')}
          </button>
        }
        {selected.length === 1 && selected[0].isNew &&
          <button
            onClick={this.onTouchNode}
            className={classNames.saveButton}
            disabled={saving || updating}>
            {saving ? 'Confirming…' : 'Confirm as new'}
          </button>
        }
        {canMerge(selected) &&
          <button
            onClick={this.onSave}
            className={classNames.saveButton}
            disabled={saving || updating}>
            {updating ? 'Refreshing…' : (saving ? 'Merging…' : 'Merge')}
          </button>
        }
        {selected.length !== 0 &&
          <button
            onClick={this.onCancel}
            className={classNames.resetButton}>
            Cancel
          </button>
        }
      </Sticky>
    )
  }
  render () {
    const { selected, saving, updating, error } = this.state
    return (
      <StickyContainer className={classNames.page}>
        {this.renderHeader()}
        <p className={classNames.note}>
          To merge nodes, select a <span className={classNames.noteOld}>Deleted or Moved</span> node and a <span className={classNames.noteNew}>New</span> node and confirm.
          <br />
          To delete a node, select only a <span className={classNames.noteOld}>Deleted or Moved</span> node and confirm.
          <br />
          To mark a node as new, select only a <span className={classNames.noteNew}>New</span> node and confirm.
          <br />
          Where possible, merge top-level nodes first – children will be automatically resolved.
        </p>
        <div className={(saving || updating) && classNames.disabled}>
          <label>
            <input
              type='checkbox'
              checked={this.state.enableAllNewNodes}
              onChange={this.toggleQuiteNewNodes}
            />
            Enable all new nodes
          </label>
          <KeywordGraphPicker
            selected={selected.map(n => n._id)}
            onSelect={this.onSelect}
            showIndicators
            showUpdatedTime='structure__updated_at'
            showBackupTime
            showOldNewCounts
            enableOld
            enableNew
            enableAllNew={this.state.enableAllNewNodes}
            stickyBarTop='59px'
          />
          <label style={{ marginBottom: '3px' }}>
            Tags
          </label>
          <KeywordGraphPicker tags disableFetch />
        </div>
        {error &&
          <p className={classNames.error}>
            Error: {error.message || error.statusText}
          </p>
        }
      </StickyContainer>
    )
  }
}

function canMerge (selected) {
  if (selected.length !== 2) {
    return false
  }
  if (selected[0].isOld && selected[1].isNew) {
    return true
  }
  if (selected[1].isOld && selected[0].isNew) {
    return true
  }
  return false
}

const mapStateToProps = ({ auth }) => ({

})

const mapDispatchToProps = {
  mergeNodes,
  deleteNode,
  touchNode,
  fetchKeywordGraph
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateKeywordStructure)



// WEBPACK FOOTER //
// ./src/pages/UpdateKeywordStructure.js